module.exports = __webpack_public_path__ + "img/4.e0a2c692.png";